import Phaser from 'phaser';
import { computeMetrics } from './dpr.js';
import { BootScene } from './scenes/BootScene';
import { LoginScene } from './scenes/LoginScene';
import { MenuScene } from './scenes/MenuScene';
import { FactionSelectScene } from './scenes/FactionSelectScene';
import { HeroSelectScene } from './scenes/HeroSelectScene';
import { BattleScene } from './scenes/BattleScene';
import { HeroScene } from './scenes/HeroScene';
import { InventoryScene } from './scenes/InventoryScene';
import { BaseScene } from './scenes/BaseScene';
import { ShopScene } from './scenes/ShopScene';
import { TomesScene } from './scenes/TomesScene';
import { AchievementScene } from './scenes/AchievementScene';
import { ArmoryScene } from './scenes/ArmoryScene';
import { CodexScene } from './scenes/CodexScene';
import { PassiveTreeScene } from './scenes/PassiveTreeScene';
import { RuneShopScene } from './scenes/RuneShopScene';
import { SigilLoadoutScene } from './scenes/SigilLoadoutScene';
import { BookBanScene } from './scenes/BookBanScene';
import { OfflineScene } from './scenes/OfflineScene';
import { PvpLobbyScene } from './scenes/multiplayer/PvpLobbyScene';
import { CoopLobbyScene } from './scenes/multiplayer/CoopLobbyScene';
import { PlacementOverlay } from './scenes/PlacementOverlay';

// Canvas is always 1920×1152 (2× game size) — Phaser Scale.FIT handles CSS fitting
const initial = computeMetrics(window.innerWidth, window.innerHeight);

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: initial.canvasW,
  height: initial.canvasH,
  backgroundColor: '#0a0806',
  render: {
    antialias: true,
    roundPixels: false,
  },
  scale: {
    mode: Phaser.Scale.NONE,
  },
  scene: [
    BootScene, LoginScene, MenuScene, FactionSelectScene, HeroSelectScene,
    BattleScene, HeroScene, InventoryScene, BaseScene, ShopScene, TomesScene,
    AchievementScene, ArmoryScene, CodexScene, PassiveTreeScene, RuneShopScene, SigilLoadoutScene, BookBanScene, OfflineScene,
    PvpLobbyScene, CoopLobbyScene, PlacementOverlay,
  ],
  audio: {
    disableWebAudio: false,
  },
  input: {
    activePointers: 2,
  },
  dom: {
    createContainer: true,
  },
};
